import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { withHandlers, setPropTypes, compose } from 'recompose'
import { pageType } from '../../../lib/propTypes'

const enhance = compose(
  setPropTypes({
    onChange: PropTypes.func.isRequired,
    onActiveChange: PropTypes.func,
    onRef: PropTypes.func,
    showLabel: PropTypes.bool
  }),
  withHandlers(() => {
    let dropdownEl

    return {
      setDropdownRef: ({ onRef }) => el => {
        dropdownEl = el
        if (onRef) {
          onRef(el)
        }
      },

      changeHandler: ({ onChange }) => name => {
        onChange(name)
        dropdownEl.stateUpdaters.toggleActive()
      },

      handleActiveChange: ({ onActiveChange }) => (isActive) => {
        if (onActiveChange) {
          onActiveChange(isActive)
        }
      }
    }
  })
)

/**
 * ListingTypeSelector - Dropdown with radio button options for listing types
 * Displays "For Rent" and "For Sale" as radio button options inside a dropdown
 */
const ListingTypeSelector = ({
  currentListingType,
  listingTypes,
  setDropdownRef,
  changeHandler,
  handleActiveChange,
  showLabel = false,
  DropdownComponent
}) => (
  <DropdownComponent
    id='listing-type'
    title={
      <Fragment>
        {showLabel && <div className='Dropdown-label'>Listing Type</div>}
        <div>{listingTypes[currentListingType].title}</div>
      </Fragment>
    }
    className='Dropdown--listingType Dropdown--searchBar'
    ref={setDropdownRef}
    onActiveChanged={handleActiveChange}
  >
    <div className='ListingTypeSelector-options'>
      <div className='ListingTypeSelector-option'>
        <input
          type='radio'
          id='listing-type-rentals'
          name='listing-type'
          value='rentals'
          checked={currentListingType === 'rentals'}
          onChange={() => changeHandler('rentals')}
          className='ListingTypeSelector-radio'
        />
        <label htmlFor='listing-type-rentals' className='ListingTypeSelector-label'>
          {listingTypes.rentals.title}
        </label>
      </div>

      <div className='ListingTypeSelector-option'>
        <input
          type='radio'
          id='listing-type-sales'
          name='listing-type'
          value='sales'
          checked={currentListingType === 'sales'}
          onChange={() => changeHandler('sales')}
          className='ListingTypeSelector-radio'
        />
        <label htmlFor='listing-type-sales' className='ListingTypeSelector-label'>
          {listingTypes.sales.title}
        </label>
      </div>
    </div>
  </DropdownComponent>
)

ListingTypeSelector.propTypes = {
  currentListingType: PropTypes.string.isRequired,
  listingTypes: PropTypes.shape({
    sales: pageType.isRequired,
    rentals: pageType.isRequired
  }).isRequired,
  changeHandler: PropTypes.func.isRequired,
  setDropdownRef: PropTypes.func.isRequired,
  handleActiveChange: PropTypes.func,
  showLabel: PropTypes.bool,
  DropdownComponent: PropTypes.elementType.isRequired
}

export default enhance(ListingTypeSelector)

